<template>
  <div class="py-8 sm:px-6 flex flex-col gap-4 main-off-white">
    <PainelComercialHeader
      v-if="dataSend.divisao"
      :finalDate="finalDate"
      @update-date="handleDateChange"
      :key="finalDate"
      :dataSend="dataSend"
      :showProgressionAndGoals="true"
      :metaTotalDivisao="metaTotalDivisao"
      :isLoading="isLoading"
    />
    <div v-else>
      <vs-alert title="Atenção!" color="warning" active="true">
        Este usuário não participa do super ranking, escolha outra
        {{ $t('divisão') }} para visualização!
      </vs-alert>
    </div>
    <DynamicMenu
      ref="dynamicMenu"
      @toggle-full-screen="handleFullScreen"
      @change-view="handleChangeView"
      @choose-division-modal="chooseDivision"
      :current-item-id="currentItemId"
      :class="{ hidden: isPresentationMode, flex: !isPresentationMode }"
      :isLoading="isLoading"
    />

    <div
      :class="{ block: isPresentationMode, hidden: !isPresentationMode }"
      class="mb-4"
    ></div>

    <component
      :is="currentView"
      v-if="dataSend.divisao"
      :key="`currentView-${currentViewKey}-${finalDate}-${isPresentationMode}`"
      :previous-data="previousRankingData[currentViewName]"
      @update-data="updatePreviousRankingData(currentViewName, $event)"
      :finalDate="finalDate"
      :is-presentation-mode="isPresentationMode"
      :dataSend="dataSend"
      @metaTotalSupervisores="metaTotalSupervisores"
    />

    <OptionsModal
      :modalData="listDivisions"
      :isVisible="modalDivisions"
      :currentCompany="currentCompany"
      @close="modalDivisions = false"
      @exhibitionConfig="exhibitionConfig"
      title="Lista de Divisões"
      :subtitle="`Selecione a ${$t('divisão')} desejada:`"
    />
  </div>
</template>

<script>
import PainelComercialHeader from './components/PainelComercialHeader.vue';
import DynamicMenu from './components/DynamicMenu.vue';
import TopSupervisores from './views/TopSupervisores.vue';
import BestConsultores from './views/BestConsultores.vue';
import BadConsultores from './views/BadConsultores.vue';
import TopInitialConsultores from './views/TopInitialConsultores.vue';
import PainelGeral from './views/PainelGeral.vue';
import { menuDynamic } from './utils/menu-dynamic';
import services from '../../../services';
import OptionsModal from '../PainelComercial/components/ModalOptions.vue';
import jwt from 'jsonwebtoken';
import { EventBus } from '../../../utils/eventBus';
import functions from '../../../utils/functions';

export default {
  name: 'PainelComercialView',
  components: { PainelComercialHeader, DynamicMenu, OptionsModal },
  data() {
    return {
      currentView: null,
      currentViewIndex: 0,
      presentationModeInterval: null,
      isPresentationMode: false,
      currentItemId: '',
      currentViewName: '',
      viewComponents: menuDynamic
        .filter(({ clickable, componentName }) => clickable && componentName)
        .map(({ componentName }) => componentName),
      currentViewKey: 0,
      previousRankingData: {
        TopSupervisores: null,
        BestConsultores: null,
        BadConsultores: null,
        TopInitialConsultores: null,
      },
      selectedDate: new Date().toISOString().substring(0, 10),
      modalDivisions: false,
      listDivisions: [],
      dataSend: {},
      decoded: null,
      currentCompany: null,
      metaTotalDivisao: null,
      isLoading: false,
    };
  },

  computed: {
    finalDate() {
      return this.selectedDate;
    },
  },
  methods: {
    handleFullScreen() {
      if (document.fullscreenElement) {
        this.exitPresentationMode();
        return;
      }

      this.enterPresentationMode();

      if (this.currentViewName === 'PainelGeral') {
        this.advanceToNextView();
      }
    },
    enterPresentationMode() {
      this.$el.requestFullscreen().then(() => {
        this.isPresentationMode = true;
        this.startPresentationMode();
      });
    },
    exitPresentationMode() {
      document.exitFullscreen().then(() => {
        this.isPresentationMode = false;
        this.stopPresentationMode();
      });
    },
    handleFullscreenChange() {
      if (!document.fullscreenElement) {
        this.isPresentationMode = false;
        this.stopPresentationMode();
      }
    },
    handleChangeView(viewName) {
      if (!viewName) {
        return;
      }
      this.currentViewKey++;
      this.currentViewName = viewName;
      const views = {
        PainelGeral,
        TopSupervisores,
        BestConsultores,
        BadConsultores,
        TopInitialConsultores,
      };
      const selectedItem = menuDynamic.find(
        ({ componentName }) => componentName === viewName,
      );

      if (selectedItem) {
        this.currentItemId = selectedItem.text;
      }

      this.currentView = views[viewName] || null;
      if (viewName === 'PainelGeral') {
        this.isLoading = true;
      }
      EventBus.$emit('view-changed');
    },
    startPresentationMode() {
      this.stopPresentationMode();
      const PRESENTATION_MODE_INTERVAL_MS = 30000;

      this.presentationModeInterval = setInterval(() => {
        if (this.isPresentationMode) {
          this.advanceToNextView();

          const { [this.currentViewIndex]: componentName } =
            this.viewComponents;
          const ignoredComponents = ['PainelGeral', 'modalDivisoes'].includes(
            componentName,
          );

          if (ignoredComponents) {
            this.advanceToNextView();
          }

          const selectedItem = menuDynamic.find(
            ({ componentName }) =>
              componentName === this.viewComponents[this.currentViewIndex],
          );

          if (selectedItem) {
            const { unique, text } = selectedItem;
            const identifier = unique || text;
            this.handleChangeView(this.viewComponents[this.currentViewIndex]);
            this.currentItemId = identifier;
          }
        }
      }, PRESENTATION_MODE_INTERVAL_MS);
    },
    stopPresentationMode() {
      if (this.presentationModeInterval) {
        clearInterval(this.presentationModeInterval);
        this.presentationModeInterval = null;
      }
    },
    updatePreviousRankingData(viewName, newData) {
      this.$set(this.previousRankingData, viewName, newData);
    },
    advanceToNextView() {
      const nextViewIndex =
        (this.currentViewIndex + 1) % this.viewComponents.length;
      const nextComponentName = this.viewComponents[nextViewIndex];
      const isNextPainelGeral = nextComponentName === 'PainelGeral';
      const finalViewIndex = isNextPainelGeral
        ? (nextViewIndex + 1) % this.viewComponents.length
        : nextViewIndex;
      const finalComponentName = this.viewComponents[finalViewIndex];

      this.currentViewIndex = finalViewIndex;

      const selectedItem = menuDynamic.find(
        (item) => item.componentName === finalComponentName,
      );
      if (selectedItem) {
        this.handleChangeView(finalComponentName);
        const identifier = selectedItem.unique || selectedItem.text;
        this.currentItemId = identifier;
      }
    },
    handleDateChange(newDate) {
      const { endDate } = newDate;
      this.selectedDate = endDate;
      this.currentItemId = 'Painel Geral';
      this.handleChangeView('PainelGeral');
    },
    async chooseDivision(value) {
      if (value) {
        await this.fetchDivisionsViewsBySector();
        this.modalDivisions = true;
        this.currentItemId = '';
      }
    },
    async fetchDivisionsViewsBySector() {
      try {
        this.$vs.loading();
        const { data } = await services.post(
          'Divisao',
          'divisoes-super-ranking',
          {
            idEmpresa: this.decoded.idEmpresa,
            idSetor: this.decoded.id_setor,
          },
        );
        this.listDivisions = data;
      } catch (error) {
        this.$vs.notify({
          title: 'Atenção!',
          text: 'Não foi possível buscar divisões',
          color: 'danger',
          position: 'top-center',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    exhibitionConfig(data) {
      this.dataSend.divisao = data.divisionName;
      this.dataSend.idEmpresa = data.companiesIds;
      this.dataSend.rankingCriteria = data.rankingCriteria;
      EventBus.$emit('division-changed');
      this.currentItemId = 'Painel Geral';
      this.handleChangeView('PainelGeral');
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }
      const { participaSuperRanking, id_empresa, id_setor, id_divisao } =
        this.decoded;

      this.currentCompany = id_empresa;
      this.dataSend = {
        idEmpresa: [this.currentCompany],
        idSetor: id_setor,
      };
      if (participaSuperRanking) {
        this.dataSend.idDivisao = id_divisao;
      }
    },
    metaTotalSupervisores(value) {
      this.metaTotalDivisao = value;
      this.isLoading = false;
    },
  },
  mounted() {
    this.getDecoded();
    this.handleChangeView('PainelGeral');
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
    EventBus.$on('date-changed', this.handleDateChange);
    this.$i18n.locale = functions.setLocaleBasedOnCompany();
  },
  beforeDestroy() {
    this.stopPresentationMode();
    document.removeEventListener(
      'fullscreenchange',
      this.handleFullscreenChange,
    );
    EventBus.$off('date-changed', this.handleDateChange);
  },
};
</script>

<style scoped>
.main-off-white {
  background-color: #f8f8f8;
}
</style>
